<template>
  <div id="app">
    <router-view ></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style  scoped>
#app {
  width: 100%;
 max-width:7.5rem;
 margin: 0 auto;
}


</style>



// WEBPACK FOOTER //
// src/App.vue